import clsx from 'clsx';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';

import DatePicker, { DEFAULT_DATE_FORMAT } from '@/src/components/common/DatePicker/DatePicker';
import DateInput from '@/src/components/common/Functions/DatePicker/DateInput/DateInput';

const INPUT_TYPES = {
  from: 'from',
  to: 'to',
};

const DATE_FORMAT = 'DD-MMM YYYY';

const DateRangePicker = ({ dates, onSetDates }) => {
  const [currentInput, setCurrentInput] = useState(INPUT_TYPES.from);
  const [selectedDates, setSelectedDates] = useState({
    from: dates.from,
    to: dates.to,
  });

  const handleChange = useCallback(
    (date) => {
      let inputKey = currentInput;
      // If from < to, just change the from directly
      if (currentInput === INPUT_TYPES.to && moment(date).isBefore(selectedDates.from)) {
        inputKey = INPUT_TYPES.from;
      } else {
        // If from is selected, make sure next select is to
        setCurrentInput((prevInput) =>
          prevInput === INPUT_TYPES.from ? INPUT_TYPES.to : INPUT_TYPES.from
        );
      }
      setSelectedDates({
        ...selectedDates,
        [inputKey]: moment(date),
        ...(inputKey === INPUT_TYPES.from && { [INPUT_TYPES.to]: null }),
      });
    },
    [dates, selectedDates, setSelectedDates, currentInput]
  );
  // const handleDateInputChange = useCallback((e, currentInput) => {}, [dates]);

  useEffect(() => {
    if (
      selectedDates.from.isSame(dates.from) &&
      selectedDates.to &&
      selectedDates.to.isSame(dates.to)
    ) {
      return;
    }

    if (selectedDates.from && selectedDates.to) {
      onSetDates(selectedDates);
    }
  }, [selectedDates]);

  return (
    <div
      className={clsx(
        'customPickerContainer',
        'tw-bg-white tw-shadow-[0px_0px_2px_0px_rgba(0,0,0,0.10)]',
        'tw-pt-[10px] tw-mt-[7px]'
      )}
    >
      <div
        className={clsx(
          'customInputContainer',
          'tw-flex tw-items-center tw-justify-between',
          'tw-bg-cfo-grey-300 tw-rounded-[3px]',
          'tw-px-[15px] tw-py-0 tw-mx-[14px]'
        )}
      >
        <div className={clsx('selectedDate tw-flex tw-items-center')}>
          <div className={clsx('fromDate tw-flex tw-items-center')}>
            <span className={clsx('tw-text-cfo-black')}>From</span>
            <DateInput
              class={clsx('dateValue tw-p-[5px] tw-max-w-[115px] tw-w-full tw-bg-cfo-grey-300')}
              onChange={handleChange}
              onFocus={() => setCurrentInput(INPUT_TYPES.from)}
              // onChange={(e) => handleChange(e, INPUT_TYPES.from)}
              // onBlur={(e) => handleInputBlur(e, 'from')}
              value={
                selectedDates.from
                  ? moment(selectedDates.from, DATE_FORMAT).format(DATE_FORMAT)
                  : null
              }
            />
          </div>
          <div className={clsx('toDate tw-flex tw-items-center')}>
            <span className={clsx('tw-text-cfo-black')}>To</span>
            <DateInput
              class={clsx('dateValue tw-p-[5px] tw-max-w-[115px] tw-w-full tw-bg-cfo-grey-300')}
              onChange={handleChange}
              onFocus={() => setCurrentInput(INPUT_TYPES.to)}
              // onChange={(e) => handleDateInputChange(e, INPUT_TYPES.to)}
              // onBlur={(e) => handleInputBlur(e, 'to')}
              value={
                selectedDates.to ? moment(selectedDates.to, DATE_FORMAT).format(DATE_FORMAT) : null
              }
            />
          </div>
        </div>
      </div>
      <DatePicker
        layout="layout1"
        dateFormat={DEFAULT_DATE_FORMAT}
        onChange={handleChange}
        // minDate={props.minDate}
        // maxDate={props.maxDate}
        // selected={selectedDates.from.format(DATE_FORMAT)}
        startDate={selectedDates.from ? selectedDates.from.format(DATE_FORMAT) : null}
        endDate={selectedDates.to ? selectedDates.to.format(DATE_FORMAT) : null}
        selectsStart={true}
        selectsEnd={true}
      />
    </div>
  );
};

export default DateRangePicker;
